import { useRef, useEffect, useState } from "react"
import Layout from '../../Layout'
import ProductGallery from "components/Products/ProductGallery"
import Information from "components/Products/Information"
import Comment from "components/Products/Comment"
import ProductsRecommendation from "components/Products/ProductsRecommendation"

export default function Dashboard() {
    return (
        <Layout>
            <div className="styles_wrapperContainer__zxrSf">
                <div className="MuiContainer-root MuiContainer-disableGutters MuiContainer-maxWidthLg" style={{ maxWidth: 1180 }}>
                    <div style={{ marginBottom: "10px" }}>
                        <nav
                            className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary"
                            aria-label="breadcrumb"
                        >
                            <ol className="MuiBreadcrumbs-ol">
                                <li className="MuiBreadcrumbs-li">
                                    <a
                                        className="styles_item_breadcrumb__eYGFd"
                                        href="/"
                                    >
                                        Trang chủ
                                    </a>
                                </li>

                                <li
                                    aria-hidden="true"
                                    className="MuiBreadcrumbs-separator"
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                    </svg>
                                </li>

                                <li className="MuiBreadcrumbs-li">
                                    <a
                                        className="styles_item_breadcrumb__eYGFd"
                                        href="/products"
                                    >
                                        Sản phẩm
                                    </a>
                                </li>

                                <li
                                    aria-hidden="true"
                                    className="MuiBreadcrumbs-separator"
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                    </svg>
                                </li>

                                <li className="MuiBreadcrumbs-li">
                                    <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">
                                        Cồn 90 độ direh perfect havico (c/1000ml)
                                    </span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <ProductGallery />
                    <Information />
                    <Comment />
                    <ProductsRecommendation />
                </div>
            </div>
        </Layout>
    )
}
